export const baseURL = "https://ferrywheel.piliveapp.com/";
export const adminBaseURL = "https://admin.piliveapp.com/";
export const key = "nyb(>g10:8U8I9EA2P{CM|J._g=of=";